/** Shown when the server answers a download without a link. */
export const NO_DOWNLOAD_LINK_MESSAGE = 'The download link could not be created. Try again.';

/**
 * Opens a download link in a new tab through a link click. The URL usually arrives after a fetch, outside the
 * click's user activation, where window.open could be popup-blocked; a new tab keeps the page open.
 * @param url The presigned URL of the file.
 */
export function openDownloadLink(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
